
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <div
          class="border-raduis-md bg-white box-shadow-xl-dark p-4"
          style="height: 300px"
        >
          <div class="title d-flex justify-content-between align-center">
            <b-skeleton variant="light" height="30px" width="50%"></b-skeleton>

            <b-skeleton variant="light" height="30px" width="48px"></b-skeleton>
          </div>
          <div class="card mt-4 card-table-no-margin-bottom">
            <b-skeleton-table
              :rows="3"
              :columns="7"
              variant="light" 
              :table-props="{ bordered: true, striped: true }"
              :show-footer='false'
            ></b-skeleton-table>
          </div>
        </div>
      </template>
      <div
        class="border-raduis-md bg-white box-shadow-xl-dark p-4"
        style="height: 300px"
      >
        <div class="title d-flex justify-content-between align-items-center">
          <div>
          <img v-if="icon"
            :src="require(`@/assets/images/sidebar-icons/${icon}`)"
            height="30"
            alt=""
          />
          <span class="text-primary mb-2 fsize-3 align-middle">
             {{title}}
          </span>
        </div> 
          <b-link
            :to="{ name: link }"
            class="bg-secondary py-1 px-4 rounded-pill text-white"
            ><span class="samll"> {{ $t("read_more") }} </span><b-icon icon="arrow-right" ></b-icon
          ></b-link>
        </div>
        <div class="mt-3">
           <slot name="content"></slot>
        </div>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
export default {
  name: 'CardTable',
  props: ['link', 'title', 'icon', 'loading'],
};
</script>
